import React, {useEffect} from 'react';
import ErrorPage403 from "../../images/page403.svg";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {setAutoRedirect} from "../../redux-store/auth";

const Page403 = () => {
    const dispatch = useDispatch();

    let navigate = useNavigate();
    const goBack = () => {
        dispatch(setAutoRedirect(null));
        setTimeout(()=>{
            navigate("/");
        },[500])
    }

    return (
        <>
            <div className={"container-fluid text-center error-page"}>
                <div className={"row pt-5"}>
                    <div className={"col-12 col-md-12 col-lg-12 col-xl-12 pt-5 error-page-image bcg-white"}>
                        <img src={ErrorPage403}/>
                    </div>
                    <div className={"col-12 col-md-12 col-lg-12 col-xl-12 error-page-number bcg-white"}>
                        <span>403</span>
                    </div>
                    <div className={"col-12 col-md-12 col-lg-12 col-xl-12 error-page-message bcg-white"}>
                        <p>Pristup ovom dokumentu je zabranjen. Nemate dovoljno ovlaštenja da bi otvorili ovaj dokument,
                            molimo vas da se obratite nadređenoj osobi za više informacija.</p>
                    </div>
                    <div className={"col-12 col-md-12 col-lg-12 col-xl-12 error-page-message bcg-white"}>
                        <button className={"btn btn-back"} onClick={goBack}>Vrati se na početnu</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page403;
